var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.575 20.213c4.391 4.425 21.664 3.037 21.664-13.055.699-.531 1.38-1.416 2.196-2.63-1.47.388-1.988.498-2.605.556.273-.168 1.224-.77 2.218-2.474-1.254.48-1.81.648-3.186 1.03C18.015.735 11.75 1.696 11.75 8.25c-.799 0-6.982-.334-10.501-5.131C.472 4.271.435 5.352.472 6.668c.012.428.2 1.72 2.175 3.288-1.076-.114-1.383-.125-2.212-.493.092.967.296 1.863.595 2.691 1.264 1.705 2.402 2.186 3.381 2.591-.932.223-1.142.07-1.993 0 1.06 2.06 2.421 3.047 4.205 3.547-.999 1.62-3.243 1.764-6.048 1.921z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgTwitter;